export const gradient = ['primary', 'primary-hovered', 'underline'];
export const isGradient = (x) => gradient.includes(x);
